import { useQuery, useQueryClient } from 'react-query'

import { user_role } from '@/services/backend/config/entities'
import { Repository } from '@/services/repository'

export const useGetUserList = (search?: string, role?: user_role) => {
  const queryClient = useQueryClient()
  const queryKey = ['useGetUserList', { search, role }]

  const query = useQuery(queryKey, async () => {
    return await Repository.Entity.User.Search({ search, role })
  })

  const invalidate = () => queryClient.invalidateQueries(queryKey)

  return { query, invalidate }
}
